<template>
    <div>
        <el-dialog
                :title="dialog.title"
                width="500px"
                :visible.sync="dialog.show"
                :close-on-click-modal='dialog.clickModal'
                :close-on-press-escape='dialog.pressEscape'
                :modal-append-to-body="false">
            <el-form :model="formData" status-icon :rules="rules" ref="form" label-width="100px" class="">
                <el-form-item label="角色名称" prop="roleName">
                    <el-input type="text" v-model="formData.roleName" maxlength="15" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="角色描述" prop="roleDesc">
                    <el-input type="text" v-model="formData.roleDesc" maxlength="15" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-switch
                        v-model="formData.status"
                        active-value="0"
                        inactive-value="1">
                    </el-switch>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('form')">添加</el-button>
                    <el-button @click="dialog.show = false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import { putRole } from "@/api/index";

    export default {
        name: "addfound",
        props: {
            dialog: Object,
            formData: Object
        },
        data() {
            return {
                rules: {
                    roleName: [
                        { required: true, message:'请输入角色名称', trigger: 'blur' }
                    ],
                    roleDesc: [
                        { required: true, message:'请选择角色描述', trigger: 'blur' }
                    ]
                }
            };
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        putRole({
                            roleName: this.formData.roleName,
                            roleDesc: this.formData.roleDesc,
                            status: this.formData.status,
                        }).then(res => {
                            if (res.success == true) {
                                this.$refs[formName].resetFields()
                                this.$emit('result', 'update')
                            }else{
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: 'error'
                                })
                            }
                        });
                    } else {
                        return false;
                    }
                });
            }
        }
    };
</script>

